
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';


@Component({
  selector: 'app-links-carousel',
  imports: [
    CarouselComponent
  ],
  templateUrl: './links-carousel.component.html',
  styleUrls: ['./links-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinksCarouselComponent {

  public tiles: CarouselTile[] = [
    {
      img: {
        src: 'assets/img/steg2.jpg',
        // width: 1120,
        // height: 744,
        alt: 'YSTM Steg am Abend',
        // srcset: [
        //   'assets/img/xs/steg2.webp 688w',
        //   'assets/img/sm/steg2.webp 912w',
        //   'assets/img/md/steg2.webp 1120w',
        //   'assets/img/lg/steg2.webp 1360w',
        //   'assets/img/xl/steg2.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
      }
    },
    {
      img: {
        src: 'assets/img/winter1.jpg',
        // width: 1120,
        // height: 840,
        alt: 'YSTM Winterlandschaft',
        // style: 'width:100%;height:100%;object-fit:cover;object-position:50% 60%;',
        objectPosition: '50% 60%',
        // srcset: [
        //   'assets/img/xs/winter1.webp 688w',
        //   'assets/img/sm/winter1.webp 912w',
        //   'assets/img/md/winter1.webp 1120w',
        //   'assets/img/lg/winter1.webp 1360w',
        //   'assets/img/xl/winter1.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
      }
    },
    {
      img: {
        src: 'assets/img/etc4.jpg',
        // width: 1120,
        // height: 217,
        alt: 'Flaggenmast YSTM',
        // srcset: [
        //   'assets/img/xs/etc4.webp 688w',
        //   'assets/img/sm/etc4.webp 912w',
        //   'assets/img/md/etc4.webp 1120w',
        //   'assets/img/lg/etc4.webp 1360w',
        //   'assets/img/xl/etc4.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
      }
    },
  ];
}
